import * as Sentry from '@sentry/browser';
import { cdnURL, sentryDSN, sentryEnvironment } from 'env';

/**
 * Configures Raven (Sentry client) with the appropriate user context.
 */
export default function configureRaven(userContext: Sentry.User | null) {

  if (!sentryEnvironment || !sentryDSN || !cdnURL) {
    return;
  }

  const messageCount: Record<string, number> = {};

  Sentry.init({
    dsn: sentryDSN,
    whitelistUrls: [cdnURL],
    sampleRate: 1,
    debug: sentryEnvironment === 'development',
    attachStacktrace: true,
    environment: sentryEnvironment,
    release: process.env.SENTRY_RELEASE,
    beforeSend(sentryEvent, hint) {
      let message;

      if (hint && hint.originalException) {
        if (typeof hint.originalException === 'string') {
          message = hint.originalException;
        } else {
          message = hint.originalException.message;
        }
      }

      // Block this user from sending more than ten of the
      // same error message in a single session.
      if (message) {
        messageCount[message] = (messageCount[message] || 0) + 1;
        if (messageCount[message] > 10) {
          return null;
        }
      }

      // Block all Sentry events that have `file:///` in
      // the URL. These are coming from users' personal
      // machines (presumably from the Microsoft
      // integration) and can very easily expose PII,
      // despite our safeguards on Sentry.
      if (sentryEvent.request && sentryEvent.request.url) {
        if (sentryEvent.request.url.indexOf('file:///') >= 0) {
          return null;
        }
      }

      return sentryEvent;
    },
  });

  Sentry.setUser(userContext);


  return Sentry;
}
